// extracted by mini-css-extract-plugin
module.exports = {"first":"Pointer_first__1GIjC","fadeIn":"Pointer_fadeIn__3fbD1","second":"Pointer_second__2jCz5","third":"Pointer_third__2tVVK"};